import { Outlet } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { Screens } from 'core/CssVariables';
import { useGetIncompleteAnimalsQuery } from 'redux/apiSlice/animal.slice';
import { SLayoutWrapper, SMainContentWrapper } from './Layout.styles';
import Footer from './Footer';
import Header from './Header';
import CompleteAnimalBar from './CompleteAnimalBar';

const Layout = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${Screens.ScreensMD})`,
  });
  const { data: incompleteAnimals, isLoading } = useGetIncompleteAnimalsQuery();
  if (isLoading) return null;
  return (
    <SLayoutWrapper>
      <Header />
      <CompleteAnimalBar data={incompleteAnimals} />
      <SMainContentWrapper
        className="container-lg"
        incompleteAnimal={!!incompleteAnimals?.count}
      >
        <Outlet />
      </SMainContentWrapper>
      {!isMobile && <Footer />}
    </SLayoutWrapper>
  );
};

export default Layout;
